export default () => {
  const blocks = document.querySelectorAll('.wp-block-support')

  if(blocks[0]) {
    blocks.forEach(block => {
      const buttons = block.querySelectorAll('button.type-tab')

      buttons.forEach(button => {
        button.addEventListener('click', (event) => {
          const target = event.target.dataset.content

          buttons.forEach(button => {
            button.classList.remove('last:bg-white')
            button.classList.remove('last:text-primary-500')
          })

          let previousBtn = document.querySelector(`button.type-tab:not(#${event.target.id})`)
          let currentBtn = event.target

          previousBtn.classList.remove('active')
          currentBtn.classList.add('active')

          document.querySelector(`.type-content:not(#${target})`).style.display = 'none'
          document.getElementById(target).style.display = 'flex'
        })
      })
    })
  }
}
